var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiLinkedinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78335 4.16665C5.78313 4.60867 5.60732 5.03251 5.2946 5.34491C4.98188 5.65732 4.55787 5.8327 4.11585 5.83248C3.67382 5.83226 3.24998 5.65645 2.93758 5.34373C2.62517 5.03102 2.44979 4.60701 2.45001 4.16498C2.45023 3.72295 2.62604 3.29912 2.93876 2.98671C3.25147 2.67431 3.67548 2.49892 4.11751 2.49915C4.55954 2.49937 4.98338 2.67517 5.29578 2.98789C5.60818 3.30061 5.78357 3.72462 5.78335 4.16665ZM5.83335 7.06665H2.50001V17.5H5.83335V7.06665ZM11.1 7.06665H7.78335V17.5H11.0667V12.025C11.0667 8.97498 15.0417 8.69165 15.0417 12.025V17.5H18.3333V10.8916C18.3333 5.74998 12.45 5.94165 11.0667 8.46665L11.1 7.06665Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiLinkedinFill);
export default __webpack_public_path__ + "static/media/ri_linkedin-fill.e6f337d7c9aa579ef7bc27d74d0d3d8a.svg";
export { ForwardRef as ReactComponent };